// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__y-kbK","button":"Nav_button__I4XtY","user":"Nav_user__0O3CP","disabled":"Nav_disabled__mzUL2","divider":"Nav_divider__jvpNv","userDetails":"Nav_userDetails__mrrHZ"};